import { QRCodeLoginPage } from './QRCodeLoginPage';
export default QRCodeLoginPage;
